import { IUser, RoleType } from "../users"

export interface IGroup {
    id: string
    name: string
    parent_id: string | null
    users: {
        id: string,
        username: string | null
        name?: string | null
        email?: string | null
        phone?: string | null
    }[]
}

export interface IGetGroupsResponse {
    page: number
    limit: number
    totalPages: number,
    items: IGroup[]
}

export interface ICreateGroup {
    parent_id?: string
    name: string
    role_id: RoleType
}

export interface IUpdateGroup {
    group_id: string
    parent_id?: string
    name?: string
}

export interface IGroupAccrualRequest {
    bonus_id: string
    amount_nano: number
    comment: string
}

export enum AclStrategy {
    INHERIT_ONLY = 'INHERIT_ONLY',
    INHERIT_PLUS_OVERRIDES = 'INHERIT_PLUS_OVERRIDES',
    OVERRIDES_ONLY = 'OVERRIDES_ONLY',
}

export enum TargetType {
    GROUP = 'group',
    USER = 'user',
}

export enum GroupAccessSource {
    SELF = "SELF",
    DIRECT = "DIRECT",
    INHERITED = "INHERITED",
    FULL_ACCESS = "FULL_ACCESS",
}

export interface IVisibilityAcl {
    id: string
    target_type: TargetType
    target_user: IUser | null
    target_group: IGroup | null
    target_id: string
    groups: IGroup[] | null
    acl_strategy: AclStrategy
}

export interface IVisibilityAclTableViewer {
    target_type: TargetType
    target_group: IGroup | null
    target_user: IUser | null
    group_access_source: GroupAccessSource | null
}

export interface IVisibilityAclTableRow {
    group: IGroup
    viewers: IVisibilityAclTableViewer[]
}

export type IVisibilityAclTableResponse = IVisibilityAclTableRow[]

export interface ISetVisibilityAclRequest {
    target_type: TargetType
    target_id: string
    visible_group_ids?: string[] | null
    acl_strategy?: AclStrategy
}